module.exports = __webpack_public_path__ + "img/3.4fd4fc8d.png";